import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=85ba4f30&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"
import style0 from "./Success.vue?vue&type=style&index=0&id=85ba4f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba4f30",
  null
  
)

export default component.exports